import type { HttpErrorResponse } from '@angular/common/http';

import {
  createEntityCollectionStore,
  getEntityCollectionActions,
  ngrxEvent,
  PickActions,
} from '@core/ngrx-legacy';
import {
  AutomationAction,
  ExecutedAction,
  ExecutedAutomation,
} from '@core/workflow-automations-types';

export const getOfferScope = (offerId: number): string => `offer:${offerId}`;

const idSelector = (action: { id: number }) => action.id;

const { actions, selectors, reducer, namespace } =
  createEntityCollectionStore<ExecutedAutomation>()('executedAutomations', {
    idSelector,
    customActions: adapter => {
      const defaultActions = getEntityCollectionActions(adapter, idSelector);
      return {
        fetchOfferCollection: (state, payload: { offerId: number }) =>
          defaultActions.fetchCollection(state, {
            scope: getOfferScope(payload.offerId),
            ...payload,
          }),
        fetchOfferCollectionSuccess: defaultActions.fetchCollectionSuccess,
        fetchOfferCollectionFailed: defaultActions.fetchCollectionFailed,

        cancelExecutedAction: ngrxEvent<{
          executedAutomationId: number;
          executedActionId: number;
        }>(),
        cancelExecutedActionSuccess: ngrxEvent<{
          executedAutomationId: number;
          executedActionId: number;
        }>(),
        cancelExecutedActionFailed: ngrxEvent<{ error: HttpErrorResponse }>(),

        cancelExecutedAutomation: ngrxEvent<{ executedAutomationId: number }>(),
        cancelExecutedAutomationSuccess: ngrxEvent<{
          executedAutomationId: number;
        }>(),
        cancelExecutedAutomationFailed: ngrxEvent<{ error: HttpErrorResponse }>(),

        updateExecutedAction: ngrxEvent<{
          executedAutomationId: number;
          executedActionId: number;
          executedAction: {
            snapshot: AutomationAction;
          };
        }>(),
        updateExecutedActionSuccess: ngrxEvent<{
          executedAutomationId: number;
          executedAction: ExecutedAction;
        }>(),
        updateExecutedActionFailed: ngrxEvent<{ error: HttpErrorResponse }>(),
      };
    },
  });

const ExecutedAutomationsActions: PickActions<
  typeof actions,
  | 'fetchOfferCollection'
  | 'cancelExecutedAction'
  | 'cancelExecutedAutomation'
  | 'updateExecutedAction'
> = actions;

export {
  ExecutedAutomationsActions,
  selectors as ExecutedAutomationsSelectors,
  reducer as ExecutedAutomationsReducer,
  namespace as ExecutedAutomationsNamespace,
};
